import { FlexRow } from '@framework/ui/components/row/FlexRow.tsx';
import { RichTextAdvancedRender } from '../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender.tsx';
import { ConfigFormItem } from '../../../../../ui/form/ConfigFormItem.tsx';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { type IAdvancedMultiSelectWidget } from '../advanced-multi-select/IAdvancedMultiSelectWidget.ts';
import { type IAdvancedSingleSelectWidget } from '../advanced-single-select/IAdvancedSingleSelectWidget.ts';
import { getWidgetProps } from '../common/util/getWidgetProps.ts';

export interface IAdvancedSelectWidgetComponentProps
  extends IWidgetComponentProps<
    IAdvancedSingleSelectWidget | IAdvancedMultiSelectWidget
  > {
  renderComponent: React.ReactNode;
  renderModal: React.ReactNode;
  formItemName?: string | string[];
}

/**
 * Widget per la selezione singola/multipla avanzata
 */
export function AdvancedSelectWidgetComponent(
  props: IAdvancedSelectWidgetComponentProps,
) {
  const { renderComponent, renderModal, formItemName } = props;
  const options = getWidgetProps(props);

  return (
    <ConfigFormItem
      name={formItemName ?? options.name}
      label={<RichTextAdvancedRender inline text={options.label} />}
      help={
        options.helpText ? (
          <RichTextAdvancedRender inline text={options.helpText} />
        ) : undefined
      }
      layout={{ hideVisualLabel: options.hideLabel }}
      readonly={options.readonly}
      widget={props.widget}
    >
      <FlexRow gutter={6} align="flex-start" right={renderModal}>
        {renderComponent}
      </FlexRow>
    </ConfigFormItem>
  );
}
